import React, { useState, useEffect } from 'react';
import './App.css';
import AppAnalytics from './mainComponent';
import LoginForm from './loginScreen';
import PageLoader from './pageLoader';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginFailed, setLoginFailed] = useState(false);
  const [initializing, setInitializing] = useState(true);

  // Check auth on every page load
  useEffect(() => {
    const savedUsername = localStorage.getItem(process.env.REACT_APP_AUTH_STORAGE_KEY);
    const savedPassword = localStorage.getItem(process.env.REACT_APP_AUTH_PASSWORD_KEY);
    if (savedUsername && savedPassword) { 
      setLoginFailed(false);
      setIsAuthenticated(true);
    }
    setInitializing(false);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();

    const headers = new Headers();
    headers.set('Authorization', 'Basic ' + btoa(username + ':' + password));

    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_API_SECURE_DATA_ENDPOINT}`;
      const res = await fetch(apiUrl, {
        method: 'GET',
        headers: headers,
      });

      if (res.ok) {
        setIsAuthenticated(true);
        localStorage.setItem(process.env.REACT_APP_AUTH_STORAGE_KEY, username);
        localStorage.setItem(process.env.REACT_APP_AUTH_PASSWORD_KEY, password);
        setLoginFailed(false);
      } else {
        setLoginFailed(true);
      }
    } catch (error) {
      console.error('Error:', error);
      if (process.env.REACT_APP_ENABLE_ERROR_ALERTS === 'true') {
        alert('Error connecting to server');
      }
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUsername('');
    setPassword('');
    localStorage.removeItem(process.env.REACT_APP_AUTH_STORAGE_KEY);
    localStorage.removeItem(process.env.REACT_APP_AUTH_PASSWORD_KEY);
    localStorage.removeItem('view_mode');
  };

  

  if(initializing){
    return (
      <PageLoader fullscreen={true}/>
    );
  };

 

  return (
    <>
    {!isAuthenticated ? (
      <LoginForm
        username={username}
        password={password}
        setUsername={setUsername}
        setPassword={setPassword}
        handleLogin={handleLogin}
        loginFailed={loginFailed}
      />
    ) : (
      <AppAnalytics handleLogout={handleLogout} />
    )}
  </>
  );
}

export default App;
